import {FC, useEffect, useState} from 'react';
import {styled} from 'styled-components';
import {useParams, useSearch} from 'wouter';

import {UnthemedNavLink} from '@shared-web/components/core/button';
import {notifyError} from '@shared-web/lib/notification';

import {ChatGptMarkdown} from '@src/components/chat_gpt_markdown';
import {LoadingScreen} from '@src/components/loading_screen';
import {apiCall} from '@src/lib/api';

export const ChampionOverviewPage: FC = () => {
  const {championName} = useParams();
  const queryString = useSearch();
  const [description, setDescription] = useState<string>();

  useEffect(() => {
    if (championName === undefined) {
      return;
    }
    apiCall('POST /gpt-champion-description', {championName})
      .then(({data}) => setDescription(data))
      .catch(notifyError);
  }, [championName]);

  if (description === undefined) {
    return (
      <WrapperLink to={`/overview?${queryString}`}>
        <LoadingScreen />
      </WrapperLink>
    );
  }

  return (
    <WrapperLink to={`/overview?${queryString}`}>
      <ChatGptMarkdown message={description} />
    </WrapperLink>
  );
};

ChampionOverviewPage.displayName = 'ChampionOverviewPage';

const WrapperLink = styled(UnthemedNavLink)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 16px;
  padding: 16px;
  overflow: auto;
  position: fixed;
  width: calc(100% - 32px);
  top: 16px;
  right: 16px;
  bottom: 16px;
  left: 16px;
  border-radius: 10px;
  background: #3737438c;
  z-index: 100;
`;
